import React, {Component} from 'react';
import ReactDOM from 'react-dom';

class Header extends Component {
  render() {
    const {children} = this.props;
    const domNode = document.getElementById('main-header');

    return domNode
      ? ReactDOM.createPortal(children, document.getElementById('main-header'))
      : null;
  }
}

export default Header;
